"use client";

import CTA from "@/components/Category/CTA";
import ToFAQ from "@/components/Category/ToFAQ";
import { site } from "@/data/default";
import { ReactNode } from "react";

const komputerKarawang: ReactNode = (
  <>
    <h2 className="text-xl font-bold mb-3">Mengapa Sewa Komputer Karawang Kian Diburu?</h2>
    <p className="mb-4">
      Karawang bukan sekadar kota industri, ia adalah titik temu kebutuhan digital dan mobilitas tinggi. Dari kawasan industri Suryacipta, KIIC, hingga area kota² yang berkembang cepat, <strong>sewa komputer Karawang</strong> menjadi opsi unggulan untuk perusahaan yang ingin lincah, hemat, dan tanpa beban perawatan jangka panjang.
    </p>

    <h3 className="text-lg font-semibold mb-2">🔍 Sewa Komputer Karawang Cocok Untuk Siapa?</h3>
    <ul className="list-disc list-inside mb-4">
      <li>Perusahaan manufaktur di kawasan industri</li>
      <li>Penyelenggara pelatihan SDM & sertifikasi</li>
      <li>Kebutuhan temporer audit & proyek</li>
      <li>Tim lapangan dan event yang butuh komputer portable</li>
    </ul>

    <h2 className="text-xl font-bold mb-3">Apa yang Membuat Layanan Kami Berbeda?</h2>
    <div className="space-y-6">
      <div className="bg-white shadow rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">💻 Spek Komputer Variatif & Siap Kerja</h4>
        <p className="text-sm">
          Dari spek standar untuk administrasi hingga high performance untuk keperluan desain dan data analyst, kami siap kirim unit <strong>sewa komputer Karawang</strong> sesuai kebutuhan kamu. Semua unit telah melalui quality check ketat.
        </p>
      </div>

      <div className="bg-white shadow rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">🛠 Maintenance & Support Langsung di Karawang</h4>
        <p className="text-sm">
          Kami punya tim teknisi lokal Karawang yang siap bantu onsite maupun remote. Setup jaringan? Troubleshooting? Unit rusak diganti? Semua ditangani dengan cepat selama masa <strong>sewa komputer Karawang</strong> berlangsung.
        </p>
      </div>

      <div className="bg-white shadow rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">📦 Pengiriman Cepat, Gratis Ongkir Pusat Kota</h4>
        <p className="text-sm">
          Area kota² seperti Galuh Mas, Karawang Barat & Timur kami prioritaskan untuk pengiriman cepat. Kami juga layani kawasan industri dengan tarif logistik transparan & profesional.
        </p>
      </div>

      <div className="bg-white shadow rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">💰 Harga Fleksibel Sesuai Durasi & Jumlah Unit</h4>
        <p className="text-sm">
          Mau sewa harian, mingguan, atau bulanan? Jumlah unit banyak? Spek tinggi? Tim kami siap bernegosiasi agar solusi <strong>sewa komputer Karawang</strong> tetap efisien dan scalable.
        </p>
      </div>
    </div>

    <h2 className="text-xl font-bold mt-8 mb-3">Fleksibilitas Durasi Sewa Komputer Karawang</h2>
    <p className="mb-4">
      Baik untuk proyek jangka pendek seperti event, pelatihan, hingga operasional bulanan di pabrik², <strong>sewa komputer Karawang</strong> hadir dengan durasi fleksibel dan bisa diperpanjang tanpa repot.
    </p>

    <h2 className="text-xl font-bold mb-3">Daftar Brand & Tipe Komputer yang Tersedia</h2>
    <ul className="list-disc list-inside mb-4">
      <li>HP ProDesk, Dell Optiplex, Lenovo ThinkCentre</li>
      <li>All-in-One PC untuk efisiensi ruang kerja</li>
      <li>Komputer mini untuk booth, stand & mobile station</li>
      <li>Unit rakitan custom sesuai kebutuhan project</li>
    </ul>

    <h2 className="text-xl font-bold mb-3">Spesifikasi Populer untuk Kebutuhan Industri</h2>
    <ul className="list-disc list-inside mb-4">
      <li>Intel Core i5/i7 Gen-8 ke atas</li>
      <li>RAM 8-16 GB DDR4, SSD 256GB+</li>
      <li>VGA Dedicated untuk keperluan desain</li>
      <li>Pre-installed software (Ms Office, Corel, Adobe, dsb)</li>
    </ul>

    <h2 className="text-xl font-bold mb-3">Keamanan Data & Privasi Pengguna Dijaga Ketat</h2>
    <p className="mb-4">
      Setiap unit <strong>sewa komputer Karawang</strong> akan di-wipe bersih sebelum dan sesudah masa sewa. Privasi kamu aman. Tim kami telah tersertifikasi untuk penanganan data sensitif.
    </p>

    <CTA
      title="Siap Kerja Tanpa Repot di Karawang & Sekitarnya?"
      description="🚛 Cari <strong>sewa komputer Karawang</strong> dengan harga fleksibel, spek custom, dan dukungan teknisi lokal? Klik tombol di bawah ini dan tim kami bantu segera."
      buttonText="Booking Komputer Sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20komputer%20untuk%20Karawang.%20Lokasi%20dan%20tanggal%20sudah%20siap.`,
          "_blank"
        );
      }}
    />

    <ToFAQ category="Komputer" />
  </>
);

export default komputerKarawang;